export interface IQuery { }

export class UserAccessTokensQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.AccessTokens.Queries.UserAccessTokensQueryV1, TCh.Domain.Organizations'

	UserId: string

	constructor (userId: string)
	{
		this.UserId = userId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.AccessTokens.Queries.UserAccessTokensQueryV1, TCh.Domain.Organizations'
	}

}

